import { createAction, props } from '@ngrx/store';
import { UpdateUser, UserData } from '@shared/interfaces';

export const loadProfile = createAction(
  '[Profile] Load'
);

export const refreshProfileAfterPayment = createAction(
  '[Profile] Refresh after payment',
  props<{ tries: number }>()
);

export const setProfile = createAction(
  '[Profile] Load Success',
  props<{ profile: UserData }>()
);

export const refreshProfile = createAction(
  '[Profile] Refresh Success',
  props<{ profile: UserData }>()
);

export const editProfile = createAction(
  '[Profile] Edit',
  props<{ data: UpdateUser }>()
);

export const updateProfile = createAction(
  '[Profile] Edit Success',
  props<{ profile: UserData }>()
);

export const loadFailure = createAction(
  '[Profile] Load Failure',
  props<{ error: any }>()
);
